import { Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AdminModuleGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  private fn = async (): Promise<boolean> => {
    // Wait until authenticated
    while (!(await this.authService.isAuthenticated())) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    await this.authService.refreshMe();

    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/no-access']);
      return false;
    }

    if (!this.authService.hasAccessToAdminPortal()) {
      this.router.navigate(['/']);
      return false;
    }

    return true;
  };

  canActivate: CanActivateFn = this.fn;
  canActivateChild: CanActivateFn = this.fn;
}
